export const inStoreBroadCastOrgId = "86e7326e-20da-410f-8694-62e4c4f70811";
const orgIdsToHideDashboard = [inStoreBroadCastOrgId];

export function isShowDashboardByOrgId(orgId: string) {
  return !orgIdsToHideDashboard.includes(orgId);
}
